import Tone from 'tone';
import Mix from 'session/Mix.js';
import PatternSwitchEvent from 'session/PatternSwitchEvent.js';
import {
    PATTERN_SWITCH,
    SEQUENCE_ROLL} from 'session/constants.js';
import TrackVolumeChangeEvent from 'session/TrackVolumeChangeEvent.js';
import {TRACK_VOLUME_CHANGE} from 'session/constants.js';
import GroupVolumeChangeEvent from 'session/GroupVolumeChangeEvent.js';
import {GROUP_VOLUME_CHANGE} from 'session/constants.js';
import TrackMuteEvent from 'session/TrackMuteEvent.js';
import {TRACK_MUTE} from 'session/constants.js';
import GroupMuteEvent from 'session/GroupMuteEvent.js';
import {GROUP_MUTE} from 'session/constants.js';
import {setMixes} from 'actions/index.js';
import {setCurrentMix} from 'actions/index.js';

const FIRST_PATTERN_EVENT = new PatternSwitchEvent(0); 

class MixSession {
    constructor(sequencerEngine) {
        this.sequencerEngine = sequencerEngine;
        this.recording = true;
        this.stopped = false;
        this.newMix();
        this.updateAllTypeRedux();
    }

    stop() {
        this.stopped = true;
    }

    newMix() {
        this.mix = new Mix(1);
    }

    seekToTrackStep(trackStep) {
        this.mix.seekToTrackStep(trackStep);
    }

    getFirstEvent(type) {
        let m = this.mix.deterministicMixesByType[type];
        return m.defaultValue;
    }

    get subSequenceMixes() {
        return this.sequencerEngine.subSequences.map(
            x => x.mix);
    }

    getJson() {
        let json = {
            mix: this.mix.getJson(),
            subSequenceMixes: this.subSequencesMixes.map(
                x => x.getJson())
        };

        return json;
    }

    loadFromJson(json) {
        console.log('mix session is loading from json');
        if (json.length > 0) {
            this.mixes = [];
        }

        for (let i in json) {
            let mixJson = json[i];
            if (mixJson.name === undefined) {
                continue;
            }
            let mix = new Mix();
            mix.loadFromJson(mixJson, this.sequencerEngine);
            this.mixes.push(mix);
       }

        this.updateAllTypeRedux();
    }

    resizeInPlace(event, newSize) {
        this.mix.resizeEvent(event, newSize, true);
        this.updateAllTypeRedux();
    }

    resizeEvent(event, newSize) {
        if (this.currentMix === undefined) {
            this.newMix();
        }
        this.currentMix.resizeEvent(event, newSize);
        this.updateAllTypeRedux();
    }

    resizeSequenceRoll(event, subEvent, direction, newSize) {
        if (this.currentMix === undefined) {
            this.newMix();
        }
        this.currentMix.resizeSequenceRoll(event, subEvent, direction, newSize);
        this.updateAllTypeRedux();
    }

    deleteEvent(event, inPlace) {
        if (this.currentMix === undefined) {
            this.newMix();
        }
        this.currentMix.deleteEvent(event, inPlace);
        this.updateAllTypeRedux();
    }

    deleteCompoundEvent(event, subEvent) {
        if (this.currentMix === undefined) {
            this.newMix();
        }
        this.currentMix.deleteCompoundEvent(event, subEvent);
        this.updateAllTypeRedux();
    }

    insertEvent(event, duration) {
        if (this.currentMix === undefined) {
            this.newMix();
        }
        this.currentMix.insertEvent(event, duration);
        this.updateAllTypeRedux();
    }

    pasteEvents(events, position) {
        if (this.currentMix === undefined) {
            this.newMix();
        }
        this.currentMix.pasteEvents(events, position);
        this.updateAllTypeRedux();
    }

    restart() {
        if (this.currentMix !== undefined) {
            this.currentMix.restart();
        }
    }

    /** 
     * Adds an event to the mix being currently recorded.
     * If pattern is not undefined, then we are adding the event
     * to that pattern's mix.
     */
    addEvent(event, pattern=undefined, looping=false) {
   }

    holdEvent(event) {
        if (this.currentMix === undefined) {
            this.newMix();
        }

        this.currentMix.holdEvent(event);
    }

    scheduleNext(trackStep, time) {
        if (this.currentMix === undefined || this.stopped) {
            return;
        }
        this.currentMix.scheduleNext(trackStep, time, this.sequencerEngine);
    }

    schedule() {
        if (this.currentMix === undefined || this.stopped) {
            return;
        }
        this.currentMix.schedule();
    }

    getValue(type, step) {
        return this.currentMix.getValue(type, step);
    }

    getEvent(type, step) {
        let x = this.currentMix.getEvent(type, step);
        return x;
    }
}

export default MixSession;
